import { Link } from "react-router-dom";

const features = [
  { icon: "ri-movie-2-line", title: "多类别内容", desc: "电影、电视剧、综艺一网打尽" },
  { icon: "ri-time-line", title: "资讯时效性", desc: "每日更新影视圈最新动态" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "地区、年份、评分快速定位" },
  { icon: "ri-heart-3-line", title: "本地收藏", desc: "一键收藏想看作品，无需登录" },
];

export default function BrandIntro() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
        <span className="h-5 w-1 rounded-full bg-accent-500"></span>
        爱妻艺 · 娱乐内容入口
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600">
        爱妻艺是一个综合性的影视作品展示与娱乐资讯发布平台，涵盖电影、电视剧、综艺等多类别内容。
        我们希望为喜爱影视剧和综艺节目的用户，提供专业丰富、界面清晰的多内容服务，
        让每一次打开都充满发现好作品的惊喜。
      </p>

      <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-4">
        {features.map((feature) => (
          <div key={feature.title} className="rounded-lg bg-background-100 p-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className={`${feature.icon} text-lg`}></i>
            </span>
            <p className="mt-2.5 text-sm font-semibold text-foreground-900">{feature.title}</p>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">{feature.desc}</p>
          </div>
        ))}
      </div>

      <Link
        to="/about"
        className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        了解爱妻艺
        <i className="ri-arrow-right-s-line"></i>
      </Link>
    </section>
  );
}